<template>
  <div class="cart-item border-b border-solid border-gray-550">
    <div class="flex flex-row space-x-0 lg:space-x-8 gap-2">
      <div class="flex-initial w-1/3 lg:min-w-max">
        <img :src="image" class="product__image" />
      </div>
      <div class="flex-1 w-auto flex flex-col">
        <template v-if="isValid">
          <div class="cart-item__description">{{ data.name }}</div>
          <div class="text-sm lg:text-lg mt-2 break-all" v-if="data.colorName">
            <span class="font-bold">{{ data.colorName }}</span
            >:
            <span class="ml-2">{{ data.color }}</span>
          </div>
          <div class="text-sm lg:text-lg mt-2 break-all" v-if="data.sizeName">
            <span class="font-bold">{{ data.sizeName }}</span
            >:
            <span class="ml-2">{{ data.size }}</span>
          </div>
          <div class="cart-item__wrap mt-4 mb-2">
            <div class="cart-item__price">
              <span>{{ $t('cartList.item.unitPrice') }}</span>
              <span class="font-light text-xxs">{{ $t('cartList.item.withTax') }}</span>
              <span>{{ $t('cartList.item.separatorColon') }}</span>
              {{ $n(isNextSubscription ? data.nextPrice : data.price, 'currency', 'ja-JP') }}
            </div>
            <div class="cart-item__quantity ml-1">
              <span class="text-red whitespace-pre-line text-center" v-if="data.is_out_stock">{{
                $t('ec-line003.content.outOfStock')
              }}</span>
            </div>
          </div>
          <div class="cart-item__total">
            <span>{{ $t('cartList.item.quantity') }}</span>
            <span>{{ $t('cartList.item.separatorColon') }}</span>
            <span>{{ data.quantity }}</span>
          </div>
          <div class="cart-item__total mt-4">
            <span>{{ $t('cartList.item.subtotal') }}</span>
            <span class="font-light text-xxs">{{ $t('cartList.item.withTax') }}</span>
            <span>{{ $t('cartList.item.separatorColon') }}</span>
            {{ $n(isNextSubscription ? data.nextSubtotal : data.subtotal, 'currency', 'ja-JP') }}
          </div>
          <div v-if="hasDiscountAmount" class="text-xs">
            <span> {{ $t('common.label.priceDiscount') }}</span>
            <span>{{ $t('cartList.item.separatorColon') }}</span>
            <span class="text-red">{{ $n(discountAmount, 'currency', 'ja-JP') }}</span>
          </div>
        </template>
        <template v-else-if="data.visible === false">
          <div class="cart-item__description">{{ $t('ec-line003.content.errorType2') }}</div>
        </template>
        <template v-else>
          <div class="cart-item__description">{{ $t('ec-line003.content.errorType1') }}</div>
        </template>
      </div>
    </div>
    <el-row v-if="data.is_product_sku_valid === false">
      <el-col :span="24" class="text-center mt-9 mb-10">
        <el-button class="secondary-btn ec-line003__secondary-btn" @click="toDetailPage">{{
          $t('ec-line003.content.checkProductDetailBtn')
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, required: true, default: () => {} },
    isSubscription: { type: Boolean, default: false },
    isNextSubscription: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    image() {
      return this.isValid ? this.data.img : require('@/assets/images/gray-image.svg')
    },
    isValid() {
      return (
        this.data.visible &&
        [undefined, true].includes(this.data.is_product_sku_valid) &&
        this.data.is_out_stock === false
      )
    },
    hasDiscountAmount() {
      if (this.isNextSubscription) {
        return this.data.nextDiscountAmount && Number(this.data.nextDiscountAmount) < 0
      }
      return this.data.discountAmount && Number(this.data.discountAmount) < 0
    },
    discountAmount() {
      return this.isNextSubscription ? this.data.nextDiscountAmount : this.data.discountAmount
    },
  },
  methods: {
    toDetailPage() {
      this.$router.push({ name: 'EC_LINE002', params: { id: this.data.product_id } })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/cart-list-item.scss';
</style>
